import React from 'react'
import './dropdown-item.css'
import rightarrowicon from '../icons/rightarrow.svg'

const DropdownItem = ({ children }) => (
  <li>
    <a href="#" className="menu-item">
      <span className="icon-button">
        <img src={rightarrowicon} alt="right arrow" />
      </span>
      {children}
    </a>
  </li>
)

export default DropdownItem
